export const HOUR_METER_ERROR = 'Enter a whole number of hours, 0 or greater.';
export const HOUR_METER_RANGE_ERROR = 'Hour Meter is too large. Enter a smaller number.';

export function validateHourMeter(value) {
  // Blank preserves the existing create default / unchanged edit behavior.
  if (value === '' || value == null) return '';
  if (!/^[0-9]+$/.test(String(value))) return HOUR_METER_ERROR;
  return Number(value) <= 2147483647 ? '' : HOUR_METER_RANGE_ERROR;
}

export function hourMeterApiError(error) {
  const data = error?.data ?? error?.response?.data;
  return data?.field === 'hourMeter' ? data.message || HOUR_METER_ERROR : '';
}
